export class Step2 {
	public intitule = 'stepper.form.simp_an.step2';

	public criteresAttrib = 'form.simp_an.getcriteresattrib';

	constructor() {}
}
